<div *ngIf="reportType === 'VeryBriefly-Officer'">
  <div class="container-fluid px-4" id="print-section">

    <!-- ================================================= -->
    <!-- ===== OVERALL REPORT HEADER (FIRST PAGE ONLY) ==== -->
    <!-- ================================================= -->
    <div class="report-header">

      <table style="width:100%;border-collapse:collapse;">
        <tr>
          <th colspan="3" class="overall-header"style="text-align:center;font-size:18px;">
            हिंदुस्तान प्रकाशन संस्था
          </th>
          <th colspan="4" class="overall-header"style="text-align:center;font-size:18px;">
            Granth Registration Ledger Report
          </th>
          <th colspan="2" class="overall-header text-end"style="text-align:center;font-size:18px;">
           दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
          </th>
        </tr>

        <tr>
          <th colspan="3" class="overall-header"style="text-align:center;font-size:18px;">
            विवेक पुस्तक प्रकाशन
          </th>
          <th colspan="4" class="overall-header"style="text-align:center;font-size:18px;">
            Office Representative Bookwise
          </th>
          <th colspan="2" class="overall-header text-end"style="text-align:center;font-size:18px;">
            Date : From {{ startDate | date:'dd-MM-yyyy' }}
            To {{ endDate | date:'dd-MM-yyyy' }}
          </th>
        </tr>
      </table>

    </div>

    <!-- =============================================== -->
    <!-- ================= DATA TABLE ================= -->
    <!-- =============================================== -->
    <table >

      <!-- ===== TABLE HEADER (REPEATS EVERY PAGE) ===== -->
      <thead >

        <tr>
          <th style="width:4%">Sr</th>
          <th style="width:50%">Office Representative</th>
          <th style="width:8%" class="text-end">Sale<br>Copies</th>
          <th style="width:8%" class="text-end">Return<br>Copies</th>
          <th style="width:8%" class="text-end">Comp<br>Copies</th>
          <th style="width:12%" class="text-end">Total Amt</th>
          <th style="width:12%" class="text-end">Receipt Amt</th>
          <th style="width:12%" class="text-end">Credit Amt</th>
          <th style="width:8%" class="text-end">Pending Amt</th>
          <th style="width:8%" class="text-end">Commission</th>
        </tr>

      </thead>

      <!-- ================= TABLE BODY ================= -->
     <tbody>

  <ng-container *ngFor="let group of groupedData">

    <!-- Book Name -->
    <tr class="book-row">
      <td colspan="10">
        <strong>Book Name : {{ group.book_name }}</strong>
      </td>
    </tr>

    <!-- Office Representative Totals -->
    <tr *ngFor="let rep of group.office_reps; let i = index">

      <td class="text-center">{{ i + 1 }}</td>

      <td>
        {{ rep.office_rep_name || '-' }}
      </td>

      <td class="text-end">
        {{ rep.rep_totals?.sale_copies || 0 }}
      </td>

      <td class="text-end">
        {{ rep.rep_totals?.return_copies || 0 }}
      </td>

      <td class="text-end">
        {{ rep.rep_totals?.complimentary_copies || 0 }}
      </td>

      <td class="text-end">
        {{ rep.rep_totals?.total_price || 0 }}
      </td>

      <td class="text-end">
        {{ rep.rep_totals?.received_amt || 0 }}
      </td>

      <td class="text-end">
        {{ rep.rep_totals?.credit_amt || 0 }}
      </td>

      <td class="text-end">
        {{ rep.rep_totals?.remaining_amt || 0 }}
      </td>

      <td class="text-end">
        {{ rep.rep_totals?.rep_commission_amt || 0 }}
      </td>

    </tr>

    <!-- Book Total -->
    <tr class="book-total">

      <td colspan="2" class="text-end">
        <strong>Book Total</strong>
      </td>

      <td class="text-end">
        <strong>{{ group.book_totals?.sale_copies || 0 }}</strong>
      </td>

      <td class="text-end">
        <strong>{{ group.book_totals?.return_copies || 0 }}</strong>
      </td>

      <td class="text-end">
        <strong>{{ group.book_totals?.complimentary_copies || 0 }}</strong>
      </td>

      <td class="text-end">
        <strong>{{ group.book_totals?.total_price || 0 }}</strong>
      </td>

      <td class="text-end">
        <strong>{{ group.book_totals?.received_amt || 0 }}</strong>
      </td>

      <td class="text-end">
        <strong>{{ group.book_totals?.credit_amt || 0 }}</strong>
      </td>

      <td class="text-end">
        <strong>{{ group.book_totals?.remaining_amt || 0 }}</strong>
      </td>

      <td class="text-end">
        <strong>{{ group.book_totals?.rep_commission_amt || 0 }}</strong>
      </td>

    </tr>

  </ng-container>

  <!-- Grand Total -->
  <tr class="grand-total">

    <td colspan="2" class="text-end" style="background:#c8753f;font-weight:bold;">
      Grand Total
    </td>

    <td class="text-end" style="background:#c8753f;font-weight:bold;">
      {{ grandSaleCopies }}
    </td>

    <td class="text-end" style="background:#c8753f;font-weight:bold;">
      {{ grandReturnCopies }}
    </td>

    <td class="text-end" style="background:#c8753f;font-weight:bold;">
      {{ grandCompCopies }}
    </td>

    <td class="text-end" style="background:#c8753f;font-weight:bold;">
      {{ grandAmount }}
    </td>

    <td class="text-end" style="background:#c8753f;font-weight:bold;">
      {{ grandReceived }}
    </td>

    <td class="text-end" style="background:#c8753f;font-weight:bold;">
      {{ grandCredit }}
    </td>

    <td class="text-end" style="background:#c8753f;font-weight:bold;">
      {{ grandRemaining }}
    </td>

    <td class="text-end" style="background:#c8753f;font-weight:bold;">
      {{ grandCommission }}
    </td>

  </tr>

</tbody>
    </table>

    <!-- ACTION BUTTONS -->
    <div class="noPrint d-flex justify-content-end gap-3 px-4 mb-4">
      <button class="btn btn-primary" (click)="exportExcel('Booking_InDetail_Bookwise')">Export</button>
      <button class="btn btn-primary" (click)="printPage()">Print</button>
      <button class="btn btn-secondary" mat-dialog-close>Close</button>
    </div>

  </div>
</div>
